'use client';

import Link from 'next/link';
import styles from './HeaderCollapsed.module.css';
import { Button, ButtonGroup } from '@/_components';
import { usePathname, useSearchParams } from 'next/navigation';

export const HeaderCollapsed = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Render nothing if already on root or a sign in page. If it's on a sign page and there's a back button, it can be really confusing since it will just try and lead them to the home page.
  if (['/', '/signin', '/set-sign-in-method'].includes(pathname)) {
    return null;
  }

  if (pathname === '/document-drop-off' && searchParams.get('token')) {
    return null;
  }

  if (pathname === '/drop-link') {
    return null;
  }

  // Render back button
  return (
    <header className={styles.headerCollapsed} data-hide-on-print="true">
      <ButtonGroup>
        <Link href="/">
          <Button intent="secondary" value="Back" iconLeft="arrow-left" />
        </Link>
      </ButtonGroup>
    </header>
  );
};
